var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-4" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("main", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "vstack gap-4" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-9" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-4 mb-3" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ReportPackageByWeight" } } },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "d-block text-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4 mb-3",
                                },
                                [_c("i", { staticClass: "bi bi-box" })]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Paquete por peso"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "d-block text-xs text-muted" },
                                  [
                                    _vm._v(
                                      "Generar\n                                                        Reporte"
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-4 mb-3" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ReportRecovery" } } },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "d-block text-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "icon icon-shape rounded-3 bg-soft-danger text-danger text-lg me-4 mb-3",
                                },
                                [
                                  _c("i", {
                                    staticClass: "bi bi-arrow-clockwise",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Recuperación"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "d-block text-xs text-muted" },
                                  [
                                    _vm._v(
                                      "Generar\n                                                        Reporte"
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-4 mb-3" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ReportSalesTax" } } },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "d-block text-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "icon icon-shape rounded-3 bg-dark text-white text-lg me-4 mb-3",
                                },
                                [
                                  _c("i", {
                                    staticClass: "bi bi-currency-dollar",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Impuesto de ventas"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "d-block text-xs text-muted" },
                                  [
                                    _vm._v(
                                      "Generar\n                                                        Reporte"
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-4 mb-3" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ReportAwb" } } },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "d-block text-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "icon icon-shape rounded-3 bg-soft-info text-info text-lg me-4 mb-3",
                                },
                                [_c("i", { staticClass: "bi bi-airplane" })]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Manifiestos"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "d-block text-xs text-muted" },
                                  [
                                    _vm._v(
                                      "Generar\n                                                        Reporte"
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-4 mb-3" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ReportInvoice" } } },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "d-block text-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "icon icon-shape rounded-3 bg-soft-success text-success text-lg me-4 mb-3",
                                },
                                [
                                  _c("i", {
                                    staticClass: "bi bi-file-earmark-diff",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Facturación"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "d-block text-xs text-muted" },
                                  [
                                    _vm._v(
                                      "Generar\n                                                        Reporte"
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-4 mb-3" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ReportRejected" } } },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "d-block text-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "icon icon-shape rounded-3 bg-primary text-white text-lg me-4 mb-3",
                                },
                                [_c("i", { staticClass: "bi bi-x-circle" })]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Rechazados"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "d-block text-xs text-muted" },
                                  [
                                    _vm._v(
                                      "Generar\n                                                        Reporte"
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-4 mb-3" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ReportAffiliations" } } },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "d-block text-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "icon icon-shape rounded-3 bg-orange text-white text-lg me-4 mb-3",
                                },
                                [_c("i", { staticClass: "bi bi-people" })]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Afiliaciones"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "d-block text-xs text-muted" },
                                  [
                                    _vm._v(
                                      "Generar\n                                                        Reporte"
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-4 mb-3" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ReportWerehouse" } } },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "d-block text-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "icon icon-shape rounded-3 bg-info text-white text-lg me-4 mb-3",
                                },
                                [_c("i", { staticClass: "bi bi-building" })]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Paquetes en bodega"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "d-block text-xs text-muted" },
                                  [
                                    _vm._v(
                                      "Generar\n                                                        Reporte"
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-3" },
              [
                _c("div", { staticClass: "form-group mb-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    attrs: { type: "text", placeholder: "Buscar.." },
                    domProps: { value: _vm.search },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.items,
                      search: _vm.search,
                      dense: "",
                      "hide-default-header": "",
                      "hide-default-footer": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.title",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "text-decoration-none",
                                  attrs: {
                                    href:
                                      _vm.endpoint.slice(0, -6) +
                                      "v1/reports/my/" +
                                      item.hash,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex gap-2 align-items-center py-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "icon icon-shape rounded-3 text-lg me-4",
                                          class: item.class,
                                        },
                                        [_c("i", { class: item.icon })]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c("h5", { staticClass: "mb-1" }, [
                                          _vm._v(_vm._s(item.title)),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "small",
                                          {
                                            staticClass:
                                              "d-block text-xs text-muted",
                                          },
                                          [_vm._v(_vm._s(item.created_at))]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "pb-4" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row align-items-end" }, [
          _c("div", { staticClass: "col-sm col-12" }, [
            _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Reportes")]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }